import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultActivitySettingsComponent } from './default-activity-settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AiMarkerSetPanelComponent } from '@go-modules/components/ai-marker-set-panel/ai-marker-set-panel.component';
import { DefaultAIMarkersDialogModule } from '@go-modules/components/dialogs/default-ai-markers-dialog/default-ai-markers-dialog.module';
import { MarkerSetPanelComponent } from '@go-modules/components/marker-set-panel/marker-set-panel.component';
import { RequiredFieldsNoteDirective } from '@go-modules/directives/required-fields-note';

@NgModule({
	imports: [
		CommonModule,
		GoMaterialModule,
		TranslateModule,
		ReactiveFormsModule,
		FormsModule,
		DefaultAIMarkersDialogModule,
		AiMarkerSetPanelComponent,
		MarkerSetPanelComponent,
		RequiredFieldsNoteDirective
	],
	declarations: [
		DefaultActivitySettingsComponent
	],
	exports: [
		DefaultActivitySettingsComponent
	]
})
export class DefaultActivitySettingsModule {}
